import { createFileRoute } from '@tanstack/react-router'

import Maintenance from '@/features/Maintenance'
import { maintenanceSearchSchema } from '@/features/Maintenance/Validation'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_public/maintenance')({
    component: RouteComponent,
    validateSearch: function (search) {
        return maintenanceSearchSchema.parse(search)
    },
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <Maintenance />
}
